import { ISelectOption } from "src/@types/form";
import { myClonesSortingTrns } from "./trns";

export const MY_CLONE_SORT_OPTIONS: ISelectOption[] = [
  {
    value: "all",
    id: "all",
    label: { i18nKey: myClonesSortingTrns.allOptionlabel },
  },
  {
    value: "active",
    id: "active",
    label: { i18nKey: myClonesSortingTrns.activeOptionlabel },
  },
  {
    value: "pause",
    id: "pause",
    label: { i18nKey: myClonesSortingTrns.pausedOptionlabel },
  },
];
